module.exports = __webpack_public_path__ + "img/746-8e7f8a.png";